import { Field, reduxForm } from "redux-form";
import { Modal, Select } from "components";
import { Button } from "expano-components";
import useUpdate from "hooks/useUpdate";
import channel_campaign_statuses_options from "utils/select_options/channel_campaign_statuses_options";

const SelectField = (props) => <Select {...props} />;

const UpdateChannelCampaignModal = ({
  id,
  channel_id,
  name,
  handleClose,
  pristine,
  invalid,
  handleSubmit,
  handleConfirm,
  initialValues,
  change,
}) => {
  const { is_updating, update } = useUpdate({
    path: `/channels/${channel_id}/channel_campaigns/${id}`,
    onSuccess: (data) => handleConfirm(data),
  });

  const onSubmit = ({ status }) =>
    update({
      status,
    });

  return (
    <Modal
      handleClose={handleClose}
      header={{
        title: name,
      }}
      footer={
        <>
          <Button type="cancel" onClick={handleClose} />
          <Button
            type="save"
            text="Zapisz"
            disabled={pristine || invalid || is_updating}
            onClick={handleSubmit(onSubmit)}
          />
        </>
      }
    >
      <Field
        name="status"
        label="Status"
        component={SelectField}
        options={channel_campaign_statuses_options}
        handleChange={(value) => change("status", value)}
        defaultValue={channel_campaign_statuses_options.find(
          ({ value }) => value === initialValues.status,
        )}
      />
    </Modal>
  );
};

const validate = (values) => {
  const errors = {};

  if (!values.status) {
    errors.status = "Pole wymagane!";
  }

  return errors;
};

export default reduxForm({
  form: "fast_update_channel_campaign",
  validate,
})(UpdateChannelCampaignModal);
